import { render, staticRenderFns } from "./LegalDocumentMessages.vue?vue&type=template&id=5ec56a84&scoped=true&"
import script from "./LegalDocumentMessages.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec56a84",
  null
  
)

export default component.exports